export const PRODUCT_MATERIAL_FRAGMENT = `
  fragment ProductMaterialFragment on ProductMaterial {
    title
    description
    extraPrice
    extraProductionDays
    isDefault
    id
  }
`

export const OFFER_MATERIAL_FRAGMENT = `
  fragment OfferMaterialFragment on OfferMaterial {
    title
    description
    extraPrice
    extraProductionDays
    isDefault
    id
  }
`
